import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b108ec1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yearpicker" }, "Chọn năm thống kê:", -1))
const _hoisted_4 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Duyệt thống kê", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-col-12 p-md-12" }, null, -1))
const _hoisted_7 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Thống kê đánh giá trong quý 1 ", -1))
const _hoisted_10 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Thống kê đánh giá trong quý 2 ", -1))
const _hoisted_13 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Thống kê đánh giá trong quý 3 ", -1))
const _hoisted_16 = { class: "col-12 p-col-3 p-md-3" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Thống kê đánh giá trong quý 4 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thống kê đánh giá chất lượng bệnh viện" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Calendar, {
            id: "yearpicker",
            modelValue: $setup.date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
            view: "year",
            dateFormat: "yy"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Button, {
            label: "Xử lý",
            type: "button",
            icon: "pi pi-spinner",
            align: "center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectDate()))
          })
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Chart, {
              type: "doughnut",
              data: $setup.totalDataInQuarter1,
              options: _ctx.lightOptions
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Chart, {
              type: "doughnut",
              data: $setup.totalDataInQuarter2,
              options: _ctx.lightOptions
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Chart, {
              type: "doughnut",
              data: $setup.totalDataInQuarter3,
              options: _ctx.lightOptions
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Chart, {
              type: "doughnut",
              data: $setup.totalDataInQuarter4,
              options: _ctx.lightOptions
            }, null, 8, ["data", "options"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}